<template>
        <div :class="['rotate-clock', { 'mobile-mode': isMobile, 'bottom-sheet-mode': isBottomSheet }]" ref="clock" @mousedown.stop.prevent="startRotate" @touchstart.prevent.stop="startRotate"
                @click.stop>
                <div v-if="isBottomSheet" class="clock-dial-wrapper" ref="dialWrapper">
                        <svg class="dial" viewBox="0 0 100 100" aria-hidden="true">
                                <circle cx="50" cy="50" r="46" class="ring" />
                                <g class="ticks">
                                        <line v-for="n in 12" :key="n" :x1="50" y1="6" :x2="50" y2="14" :transform="`rotate(${(n - 1) * 30} 50 50)`" />
                                </g>
                        </svg>
                        <div class="rotate-arrow" :style="{ transform: `rotate(${currentAngle}deg)` }"></div>
                </div>
                <template v-else>
                        <svg class="dial" viewBox="0 0 100 100" aria-hidden="true">
                                <circle cx="50" cy="50" r="46" class="ring" />
                                <g class="ticks">
                                        <line v-for="n in 12" :key="n" :x1="50" y1="6" :x2="50" y2="14" :transform="`rotate(${(n - 1) * 30} 50 50)`" />
                                </g>
                        </svg>
                        <div class="rotate-arrow" :style="{ transform: `rotate(${currentAngle}deg)` }"></div>
                </template>
        </div>
</template>

<script>
export default {
        name: 'AppClockRotatePicker',
        props: {
                initialAngle: { type: Number, default: 0 },
                isMobile: { type: Boolean, default: false },
                isBottomSheet: { type: Boolean, default: false }
        },
        emits: ['update', 'close', 'start'],
        data() {
                return {
                        currentAngle: this.initialAngle,
                        // eslint-disable-next-line vue/no-reserved-keys
                        _moveHandler: null,
                        // eslint-disable-next-line vue/no-reserved-keys
                        _upHandler: null
                }
        },
        watch: {
                initialAngle(newVal) {
                        this.currentAngle = newVal ?? 0
                }
        },
        mounted() {
                // Клик вне — закрыть
                document.addEventListener('mousedown', this.handleOutsideClick)
                document.addEventListener('touchstart', this.handleOutsideClick)
        },
        beforeUnmount() {
                this.removeMoveListeners()
                document.removeEventListener('mousedown', this.handleOutsideClick)
                document.removeEventListener('touchstart', this.handleOutsideClick)
        },
        methods: {
                handleOutsideClick(e) {
                        if (!this.$refs.clock.contains(e.target)) {
                                this.$emit('close')
                        }
                },
                startRotate(e) {
                        if (e && e.type === 'mousedown') e.preventDefault()
                        this.$emit('start')

                        this._moveHandler = (ev) => {
                                const targetRef = this.isBottomSheet && this.$refs.dialWrapper ? this.$refs.dialWrapper : this.$refs.clock
                                const rect = targetRef.getBoundingClientRect()
                                const centerX = rect.left + rect.width / 2
                                const centerY = rect.top + rect.height / 2
                                const clientX = ev.touches ? ev.touches[0].clientX : ev.clientX
                                const clientY = ev.touches ? ev.touches[0].clientY : ev.clientY
                                const dx = clientX - centerX
                                const dy = clientY - centerY
                                const angle = Math.atan2(dy, dx) * (180 / Math.PI)
                                this.currentAngle = (angle + 90 + 360) % 360
                                this.$emit('update', this.currentAngle)
                        }

                        this._upHandler = () => this.removeMoveListeners()

                        document.addEventListener('mousemove', this._moveHandler)
                        document.addEventListener('mouseup', this._upHandler)
                        document.addEventListener('touchmove', this._moveHandler, { passive: false })
                        document.addEventListener('touchend', this._upHandler)
                },
                removeMoveListeners() {
                        if (this._moveHandler) {
                                document.removeEventListener('mousemove', this._moveHandler)
                                document.removeEventListener('touchmove', this._moveHandler)
                                this._moveHandler = null
                        }
                        if (this._upHandler) {
                                document.removeEventListener('mouseup', this._upHandler)
                                document.removeEventListener('touchend', this._upHandler)
                                this._upHandler = null
                        }
                }
        }
}
</script>

<style scoped>
.rotate-clock {
        position: absolute;
        width: 90px;
        height: 90px;
        top: -105px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: auto;
        user-select: none;
        z-index: 9999;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 50%;
        box-shadow:
                0 4px 8px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(6px);
        transition: box-shadow 0.2s ease;
}

.rotate-clock:hover {
        box-shadow:
                0 6px 12px rgba(0, 0, 0, 0.15);
}

.dial {
        position: absolute;
        width: 90px;
        height: 90px;
        overflow: visible;
}

.ring {
        fill: rgba(255, 255, 255, 0.85);
        stroke: rgba(0, 0, 0, 0.15);
        stroke-width: 2;
        rx: 50%;
        ry: 50%;
}

.ticks line {
        stroke: rgba(0, 0, 0, 0.25);
        stroke-width: 1;
        stroke-linecap: round;
}

.rotate-arrow {
        position: absolute;
        width: 4px;
        height: 38px;
        background: linear-gradient(to top, #ff4d4f, #ff8080);
        bottom: 50%;
        left: 50%;
        transform-origin: bottom center;
        border-radius: 2px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
        transition: transform 0.03s linear;
        pointer-events: none;
}

.rotate-clock.mobile-mode {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 120px;
        height: 120px;
        z-index: 10000;
}

.rotate-clock.mobile-mode .dial {
        width: 120px;
        height: 120px;
}

.rotate-clock.mobile-mode .rotate-arrow {
        height: 50px;
}

.rotate-clock.bottom-sheet-mode {
        position: fixed;
        top: auto;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 400px;
        height: auto;
        padding: 40px 20px;
        padding-bottom: calc(30px + env(safe-area-inset-bottom));
        background: #fff;
        border-radius: 16px 16px 0 0;
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
        z-index: 10000;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
}

.clock-dial-wrapper {
        position: relative;
        width: 160px;
        height: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
}

.rotate-clock.bottom-sheet-mode .dial {
        width: 160px;
        height: 160px;
}

.rotate-clock.bottom-sheet-mode .rotate-arrow {
        position: absolute;
        height: 70px;
        bottom: 50%;
        left: 50%;
        transform: translateX(-50%);
}
</style>
